import React, { useEffect, useMemo } from "react";

import { useImage } from "@common/util/useImage";
import { URI } from "../../types";
import { Loading } from "./Loading";

type Props = Readonly<{
  onImageLoaded: (image: HTMLImageElement) => void;
  src: URI;
}>;

export const PreviewImage = ({ onImageLoaded, src }: Props) => {
  const [image, status] = useImage(src, true, true);
  const previewImageStyles = useMemo(() => {
    if (!image || status !== "loaded") {
      return {};
    }
    return {
      backgroundImage: `url(${image.src})`,
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
    };
  }, [image, src, status]);
  useEffect(() => {
    if (image && status === "loaded") {
      onImageLoaded(image);
    }
  }, [image, status]);
  if (status === "loaded") {
    return <div style={previewImageStyles} />;
  }
  return <Loading />;
};
